import { bootstrapApplication } from '@angular/platform-browser';
import { installMockUser } from '@partou/core';
import { App } from './app/app';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

if (environment.useMocks) installMockUser();

bootstrapApplication(App, appConfig).catch((err: unknown): void => console.error(err));
